// Map Initialization Module - main entry point for map setup
import { getToken } from './map.token.js';
import MapDrawing from './map.core.drawing.js';
import MapLayers from './nhc.layers.js';
import MapParcelGeometry from './map.core.parcelgeometry.js';
import MapInspect from './map.core.inspect.js';

$(document).ready(function () {
    
    // Suppress 404 errors for missing vector tiles (common at edge of coverage)
    // These are expected and don't need to clutter the console
    const originalConsoleError = console.error;
    console.error = function(...args) {
        // Filter out 404 errors from Azure Blob Storage tile requests
        const message = args.join(' ');
        const mapTilesUrl = window.mapTilesBaseUrl || 'byright-fjgjhcbmdehsfach.z03.azurefd.net';
        if ((message.includes('byrightmaps.blob.core.windows.net') || message.includes(mapTilesUrl)) && 
            (message.includes('404') || message.includes('Not Found') || message.includes('Failed to load'))) {
            // Silently ignore missing tile 404s
            return;
        }
        // Log all other errors normally
        originalConsoleError.apply(console, args);
    };

    // Initialize the map
    // Detect mobile device for zoom level
    const isMobile = window.innerWidth <= 576;
    const initialZoom = isMobile ? 10 : 12;
    
    window.map = new atlas.Map('map', {
        center: [-77.887117, 34.215190],
        zoom: initialZoom,
        style: 'blank', //satellite_road_labels

        authOptions: {
            authType: 'anonymous',
            clientId: '6e0db76b-5702-4798-9c9a-405de3e52e5e',
            getToken: async (resolve, reject) => {
                try {
                    resolve(await getToken()); // your existing cached token function
                } catch (e) {
                    reject(e);
                }
            }
        }
    });




    window.map.events.add('ready', async () => {
        MapLayers.setupNHCBaseMapLayers(map);
        MapLayers.setupNHCWetLandsLayers(map);
        MapLayers.setupTOWBZoningLayers(map);
        MapLayers.setupTOCBZoningLayers(map);
        MapLayers.setupTOCBHeightOverlayDistrictLayer(map);
        MapLayers.setupNHCZoningLayers(map);
        MapLayers.setupNHCParcelsLayers(map);
        MapLayers.setupNHCMuniLimitsLayers(map);
        MapLayers.setupWILMINGTONZoningLayers(map);
        MapLayers.setupWILMINGTONHistoricLayer(map);
        MapLayers.setupWILMINGTON1945Layer(map);
        MapLayers.setupNHCFloodLayers(map);
        // Default overlay layers off
        if (MapLayers && MapLayers.toggleLayerGroup) {
            MapLayers.toggleLayerGroup('wilmington-historic', false);
            MapLayers.toggleLayerGroup('wilmington-1945', false);
            MapLayers.toggleLayerGroup('tocb-heightoverlay', false);
        }

        // Initialize drawing tools
        MapDrawing.initialize(map);
        
        // Initialize parcel geometry module for side length labels
        if (MapParcelGeometry) {
            MapParcelGeometry.initialize(map);
        }
        
        // Initialize map inspection (click to see properties)
        // Store map reference for Vue to initialize later
        window.mapInstance = map;
        
        // Try to initialize if Vue app is already available
        if (MapInspect && window.vueAppInstance) {
            MapInspect.initialize(map, window.vueAppInstance);
        } else {
            // If Vue isn't ready yet, wait a bit and try again
            setTimeout(() => {
                if (MapInspect && window.vueAppInstance && window.mapInstance) {
                    MapInspect.initialize(window.mapInstance, window.vueAppInstance);
                }
            }, 500);
        }

        // Detect user location asynchronously (non-blocking)
        detectUserLocation(map);
    });

    // Check if coordinates are within a parcel boundary via API
    async function isPointInParcelBoundary(latitude, longitude) {
        try {
            const response = await ApiClient.get(`/api/Parcel/contains-point?latitude=${latitude}&longitude=${longitude}`);
            if (!response.ok) {
                console.debug('Error checking if point is in parcel boundary:', response.status);
                return false;
            }
            const data = await response.json();
            return data.contains === true;
        } catch (err) {
            console.debug('Error checking if point is in parcel boundary:', err);
            return false;
        }
    }

    // Detect user location and adjust map if within a parcel boundary
    async function detectUserLocation(map) {
        if (!navigator.geolocation) {
            // Geolocation not supported, use defaults
            return;
        }

        try {
            navigator.geolocation.getCurrentPosition(
                async (geo) => {
                    try {
                        const latitude = geo.coords.latitude;
                        const longitude = geo.coords.longitude;
                        const userPos = [longitude, latitude];

                        // Check if point is within a parcel boundary via API
                        const isInBoundary = await isPointInParcelBoundary(latitude, longitude);

                        if (isInBoundary) {
                            // Zoom to user location
                            window.map.setCamera({
                                center: userPos,
                                zoom: 16
                            });
                        }
                        // If not in boundary, map already has default center and zoom
                    } catch (err) {
                        console.debug('Error processing geolocation:', err);
                        // Silently fail, use defaults
                    }
                },
                (err) => {
                    console.debug('Geolocation error:', err.message);
                    // Silently fail, use defaults
                },
                {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 60000
                }
            );
        } catch (err) {
            console.debug('Error setting up geolocation:', err);
            // Silently fail, use defaults
        }
    }
    
});
